import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const Search = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "search" */ './search')),
});
